import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Selectsearch from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import {
	FormGroup,
	Label,
	
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import { 
 
    editRangePutting,
 } from 'Actions';

class EditItems extends React.Component {
  
    static propTypes = {
        classes: PropTypes.object,
        prev:0,

    };

    UNSAFE_componentWillMount() {
	}
    constructor(props) {
      
        super(props);
        this.state = {  
            seldate:new Date(this.props.data.seldate),             
            eid:this.props.data.eid, 
            student:this.props.data.student, 
        };
    }


    selectdate = (date) => {
        const seldate =moment(new Date(date)).format('yyyy-MM-DD');
        this.setState({ seldate:date });        
    }    

    editHandleSubmit(event){
        event.preventDefault();
        var id=this.state.eid;
        var stdid=this.state.student;
        this.props.editRangePutting(event, id, stdid);
        
        setTimeout(() => {
            this.props.onClick();
        }, 2000);  
    }  


render() {
      
    const { particularrangeputting, loading} = this.props; 

      return(
        <div>
             <div className="col-md-12">
                <form autoComplete="off" id="editform" onSubmit={(e)=>this.editHandleSubmit(e)}>
                     <div className="row">
                        <div className="col-sm-12 col-md-8" style={{margin:"0 auto"}}>
                        <RctCollapsibleCard heading="Edit Putting">   
                                <div className="row float-right"> 
                                    <button type="button" className="mr-3 mb-3 btn btn-outline-warning float-right" onClick={this.props.onClick} >Back</button>
                                </div>  
                                    <div className="row">   
                                        <div className="col-sm-12 col-md-7">
                                            <FormGroup>
                                                <Label for="date">Date *</Label>
                                                <DatePicker className="form-control" id="seldate"  name="seldate" autoComplete="off" required
                                                        selected={this.state.seldate}
                                                        onChange={this.selectdate}
                                                        dateFormat='yyyy-MM-dd'
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                    /> 
                                            </FormGroup>                                          
                                        </div>                               
                                        <div className="col-sm-12 col-md-7">   
                                            <FormGroup>
                                                <Label for="name">Coach Name *</Label>
                                                <input type="text" name="coachname" id="coachname" className="form-control form-control-alternative" defaultValue={particularrangeputting.grp_coachname} required/>
                                            </FormGroup>  
                                        </div> 
                                        <div className="col-sm-12 col-md-10">
                                            <FormGroup>
                                                <Label for="Select">Observation</Label>
                                                <textarea rows="3" type="text" name="observation" id="observation" className="form-control form-control-alternative" defaultValue={particularrangeputting.grp_observation}></textarea>
                                            </FormGroup>
                                       </div>
                                       <div className="col-sm-12 col-md-10">
                                            <FormGroup>
                                                <Label for="Select">Work in Progress</Label>
                                                <textarea rows="3" type="text" name="workin" id="workin" className="form-control form-control-alternative" defaultValue={particularrangeputting.grp_workinprocess}></textarea>
                                            </FormGroup>
                                       </div>
                                       <div className="col-md-12">
                                        <div className="form-group"> 
                                            <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Update" />     
                                        </div>
                                       </div>
                                    </div>    
                            </RctCollapsibleCard>
                         </div>   
                        </div>
                      </form>
                       </div>
                </div>
              
    )
   
}
 
}

const mapStateToProps = ({ rangeputting}) => {
   
    const { particularrangeputting, loading } = rangeputting;
    return { particularrangeputting, loading };
   
}


export default connect(mapStateToProps, {
  
    editRangePutting,
})(EditItems);
